import { TimerType } from '@sworkit/workout/dist/types/supporting/types';
import { TypeKeys, ActionTypes } from '../actions/index';

const getInitialState = (): WorkoutPlayerState => {
  return {
    dismissedLive: false,
    workoutName: null,
    timerType: null,
    online: false,
    exerciseName: null,
    exercises: [],
    currentVideoPoster: null,
    workoutTimeLeft: null,
    isYoga: false,
    totalWorkoutTimerColor: null,
    totalWorkoutTimerPercentage: 100,
    exerciseTime: null,
    exerciseTotalTime: null,
    timerColor: null,
    playColor: null,
    showNextExercise: false,
    nextExerciseName: null,
    nextExerciseImage: null,
    showPlaylist: true,
    workoutStarted: false,
    currentVideoURL: null,
    isPlaying: false,
    workoutLength: null,
    swWorkoutReady: false,
    workoutSlug: null,
    isTimerReset: false,
    workoutSettings: {
      userYogaRounds: null,
      userWorkoutLength: null,
      userCircuitRounds: null,
      breakFrequency: null,
      breakLength: null,
      exerciseLength: null,
      shouldShuffleExercises: null,
      shouldPlayExerciseNameAudio: null,
      shouldPlayNextExerciseAudio: null,
      shouldPerformWarmUp: null,
      shouldPlayRestBreaks: null,
      shouldPlayInstructionalCues: null,
      countdownAudioStyle: null,
      leadInBreakSeconds: null,
      trainerVoice: null,
      shouldPlayWelcomeAndCongratsAudio: null,
      poseLength: null,
    },
    currentExerciseIndex: 0,
    isPlan: false,
    currentWarmup: 0,
    warmUpCount: 0,
    currentCircuit: 0,
    circuitCount: 0,
    isWarmUp: false,
    isCooldown: false,
    firstCooldownExerciseName: null,
    firstCooldownExerciseImage: null,
    preloadError: false,
    hasWorkoutEnded: false,
    workoutTimingStyle: null,
    exerciseTimingStyle: null,
    workoutTime: null,
    totalTimeLogged: null,
    estimatedTotalTime: null,
    exerciseReps: null,
    allowRestBreaks: true,
    allowShuffle: true,
    allowWarmup: true,
    showNextTooltip: true,
    downloadProgress: 0,
    canChangeSides: false,
    exerciseSlug: null,
    showPreviewPanel: false
  };
};

const workoutPlayer = (
  state = getInitialState(),
  action: ActionTypes
): WorkoutPlayerState => {
  switch (action.type) {
    case TypeKeys.UPDATE_WORKOUT_PLAYER: {
      const totalWorkoutTimerColor = getWorkoutTimerColor(
        action.workoutPlayerState.timerType,
        state.totalWorkoutTimerColor
      );
      const timerColor = getExerciseTimerColor(
        action.workoutPlayerState.timerType
      );
      const playColor = timerColor;
      const exercises = action.workoutPlayerState.exercises
        ? action.workoutPlayerState.exercises
        : state.exercises;
      const downloadProgress = getDownloadProgress(exercises);
      return {
        ...state,
        ...action.workoutPlayerState,
        totalWorkoutTimerColor,
        timerColor,
        playColor,
        downloadProgress,
      };
    }
    case TypeKeys.SKIP_EXERCISE: {
      const workoutPlayer = state;
      let showNextTooltip = state.showNextTooltip;
      if (
        showNextTooltip &&
        workoutPlayer.exerciseTimingStyle === 'rep' &&
        workoutPlayer.timerType === 'exercise'
      ) {
        showNextTooltip = false;
      }
      return {
        ...state,
        showNextTooltip,
      };
    }
    case TypeKeys.TOGGLE_SHOW_PREVIEW_PANEL: {
      return {
        ...state,
        showPreviewPanel: action.showPreviewPanel
      }
    }
    case TypeKeys.TOGGLE_SHOW_PLAYLIST: {
      return {
        ...state,
        showPlaylist: action.showPlaylist,
      };
    }
    case TypeKeys.LOAD_WORKOUT: {
      return {
        ...state,
        workoutSlug: action.workoutSlug,
        swWorkoutReady: false
      };
    }
    case TypeKeys.SW_WORKOUT_READY: {
      return {
        ...state,
        ...action.workoutPlayerState,
        swWorkoutReady: true,
      };
    }
    case TypeKeys.END_WORKOUT: {
      return getInitialState();
    }
  }
  return state;
};

export default workoutPlayer;

function getWorkoutTimerColor(
  timerType: TimerType,
  defaultColor: string
) {
  switch (timerType) {
    case 'lead-in': {
      return 'var(--color-sw-feature-1)';
    }
    case 'warm-up': {
      return 'var(--color-sw-feature-2)';
    }
    case 'exercise': {
      return 'var(--color-sw-orange)';
    }
    case 'cooldown': {
      return 'var(--color-sw-blue)';
    }
    default: {
      return defaultColor;
    }
  }
}

function getExerciseTimerColor(timerType: TimerType) {
  switch (timerType) {
    case 'lead-in': {
      return 'var(--color-sw-feature-1)';
    }
    case 'warm-up': {
      return 'var(--color-sw-feature-2)';
    }
    case 'cooldown': {
      return 'var(--color-sw-blue)';
    }
    default: {
      return 'var(--color-sw-orange)';
    }
  }
}
function getDownloadProgress(exercises: WorkoutPlayerState['exercises']) {
  let progress = 0;
  if (!exercises || !exercises.length) return progress;
  const total = exercises.length;
  let downloaded = 0;
  exercises.map((exercise) => {
    if (exercise['isDownloaded']) {
      downloaded++;
    }
  });
  return downloaded / total;
}
